<template>
    <b-row>
        <b-col cols="auto" v-for="status in availableStatuses" :key="status.value">
            <b-form-checkbox v-model="currentStatus[status.value]">
                {{status.name}}
                <b-badge pill :variant="statusVariant(status.value)" class="ml-1 badge-pill-sm">
                    {{status.count}}
                </b-badge>
            </b-form-checkbox>
        </b-col>
    </b-row>
</template>
<script>
  import startCase from "lodash/startCase";
  import groupBy from "lodash/groupBy";
  import AssetStatus from "../../../models/AssetStatus";

  export default {
    model: {
      prop: 'currentStatus',
      event: 'change'
    },

    props: ['currentStatus', 'assets'],

    data() {
      return {
        prevStatus: Object.assign({}, this.currentStatus || {})
      }
    },

    watch: {
      currentStatusValues(val, oldVal) {
        if (!this.prevStatus.all && this.currentStatus.all) {
          this.clearOtherFilters()
        } else if (this.currentStatus.all) {
          if (Object.keys(this.currentStatus).filter(k => k !== 'all' && this.currentStatus[k]).length > 0) {
            this.currentStatus.all = false;
          }
        }
        this.prevStatus = Object.assign({}, this.currentStatus || {});
      }
    },

    methods: {
      statusVariant(status) {
        return AssetStatus.statusVariants[status] || 'dark'
      },
      clearOtherFilters() {
        Object.keys(this.currentStatus).filter(k => k !== 'all').forEach(k => this.currentStatus[k] = false)
      }
    },

    computed: {
      currentStatusValues: function () {
        return Object.keys(this.currentStatus).map(k => this.currentStatus[k]), Date.now();
      },

      assetsGroupedByStatus() {
        return groupBy(this.assets, asset => asset.status);
      },

      availableStatuses() {
        let allStatuses = [{
          name: 'All',
          value: 'all',
          count: this.assets.length
        }];

        if (this.assetsGroupedByStatus && Object.keys(this.assetsGroupedByStatus).length > 0) {
          const existingStatuses = Object.keys(this.assetsGroupedByStatus).map(status => {
            return {
              name: startCase(status),
              value: status,
              count: this.assetsGroupedByStatus[status].length
            }
          });

          allStatuses = allStatuses.concat(existingStatuses)
        }

        return allStatuses;
      },
    }
  }
</script>